import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/lea-policy/page.jsx")